<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ formTitle }}
          </p>
        </header>

        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="name"
              :label="$t('attributes.country')"
            >
              <b-autocomplete
                ref="country_input"
                v-model="selectedCountryName"
                name="selectedCountry"
                field="name"
                :data="countries"
                :loading="loadItems"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.country_name') +
                    '或' +
                    $t('attributes.code')
                "
                :open-on-focus="false"
                @typing="loadingCountries"
                @select="onSelectCountry"
              >
                <template #default="props">
                  <p>{{ props.option.code }} {{ props.option.name }}</p>
                </template>
                <template #empty>
                  {{
                    form.country_code
                      ? loadItems
                        ? $t('attributes.searching')
                        : $t('attributes.not_found')
                      : $t('message.please_input') +
                        $t('attributes.country_name')
                  }}
                </template>
              </b-autocomplete>
            </form-group>
            <form-group
              horizontal
              name="code"
              :label="$t('attributes.city') + $t('attributes.code')"
            >
              <b-input
                v-model="form.code"
                name="code"
                maxlength="3"
                :has-counter="false"
                :disabled="isUpdate"
                :placeholder="
                  $t('message.please_input') +
                    $t('attributes.city') +
                    $t('attributes.code')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="english_name"
              :label="$t('attributes.english_name')"
            >
              <b-input
                v-model="form.english_name"
                name="english_name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.english_name')
                "
                expanded
              >
              </b-input>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{
              this.cityTemplate.code
                ? $t('attributes.update')
                : $t('attributes.add')
            }}
          </b-button>
        </footer>

        <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { COUNTRY_TEMPLATES_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import debounce from 'lodash/debounce'

export default {
  name: 'CityTemplateForm',

  props: {
    cityTemplate: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sending: false,
      isUpdate: !!this.cityTemplate.code,
      labelPosition: 'on-border',
      selectedCountryName: this.cityTemplate.country_name,
      loadItems: false,
      countries: [],
      form: this.extractFormValues(this.cityTemplate)
    }
  },
  validations: {
    form: {
      code: { required, minLength: minLength(3), maxLength: maxLength(3) },
      name: { required, maxLength: maxLength(50) },
      english_name: { required, maxLength: maxLength(50) },
      country_code: { required },
      country_name: {}
    }
  },
  computed: {
    formTitle() {
      let title = this.cityTemplate.code
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.city_template')

      return title
    },
    isLoading() {
      return this.sending
    }
  },
  mounted() {
    this.loadCountries()
  },
  methods: {
    extractFormValues(data) {
      return {
        code: data.code && data.code.trim(),
        name: data.name && data.name.trim(),
        english_name: data.english_name && data.english_name.trim(),
        country_code: data.country_code,
        country_name: data.country_name
      }
    },
    async loadCountries() {
      try {
        const api = `${COUNTRY_TEMPLATES_API}/list`
        const params = {
          search: this.selectedCountryName
        }
        this.loadingItems = true
        const res = await this.axios.get(api, { params })
        this.countries = res.data.data
      } catch (e) {
        this.countries = []

        notifyService.fetch_error('country_template', e)
      } finally {
        this.loadingItems = false
      }
    },
    loadingCountries: debounce(function() {
      this.loadCountries()
    }, 500),
    onSelectCountry(option) {
      this.form.country_code = option.code
      this.form.country_name = option.name
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
